import LockupAddToCartButtonContainer from './lockupAddToCartButtonContainer'

export default LockupAddToCartButtonContainer
